// src/pages/Profile.jsx
import React from 'react';
import UserProfile from '../components/profile/UserProfile';

const Profile = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-4xl font-bold mb-6 text-center">User Profile</h1>
      <UserProfile />
    </div>
  );
};

export default Profile;


// import React from 'react';
// import UserProfile from '../components/profile/UserProfile';

// const Profile = () => {
//   return (
//     <div className="max-w-7xl mx-auto px-6 py-10">
//       <h1 className="text-3xl font-bold mb-6">User Profile</h1>
//       <UserProfile />
//     </div>
//   );
// };

// export default Profile;



// import React from 'react';
// import UserProfile from '../components/profile/UserProfile';
 
// const Profile = () => {
//   return (
//     <div className="container">
//       <h1>UserProfile</h1>
// <UserProfile/>
//     </div>
//   );
// };

// export default Profile;
